export const createSenderID = (builder) => ({
    createSenderID: builder.mutation({
        query: (payload) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/register_sender_id',
                method: 'POST',
                body: payload,
                headers: {
                    'Authorization': token,
                },
            };
        },
    }),
});
